import React from "react";
import { Box, Container, Typography } from "@mui/material";
import Search from "../../assets/images/about-work-search.png";
import Details from "../../assets/images/about-work-details.png";
import useMediaQuery from "@mui/material/useMediaQuery";
import Contact from "../../assets/images/about-work-contact.png";
import MobSearch from "../../assets/images/work-mob-searc.png";
import MobDetails from "../../assets/images/work-mob-details.png";
import MobContact from "../../assets/images/work-mob-contact.png";

function Working() {
  const mobMatch = useMediaQuery("(max-width:600px)");

  return (
    <Box sx={{ background: "#fff", padding: { xs: "24px 16px", sm: "0px" } }}>
      <Typography
        variant="h2"
        sx={{
          fontSize: "32px",
          lineHeight: "36px",
          fontWeight: "700",
          color: "text.primary",
          textAlign: "center",
        }}
      >
        How it works?
      </Typography>
      <Container
        disableGutters={true}
        sx={{ width: { sm: "900px" }, marginY: { xs: "32px", sm: "72px" } }}
      >
        <Box
          sx={{
            display: "flex",
            flexFlow: { xs: "column", sm: "row" },
            columnGap: "56px",
            alignItems: { sm: "center" },
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ textAlign: { xs: "center", sm: "start" } }}>
            <Typography
              variant={mobMatch ? "subtitle1" : "h3"}
              sx={{
                fontSize: { xs: "16px", sm: "22px" },
                lineHeight: { xs: "24px", sm: "26px" },
                fontWeight: "600",
                color: "text.primary",
                marginBottom: "8px",
              }}
            >
              1. Start your search
            </Typography>
            <Typography
              variant={mobMatch ? "body2" : "body1"}
              sx={{
                fontSize: { xs: "14px", sm: "16px" },
                lineHeight: { xs: "20px", sm: "24px" },
                fontWeight: "400",
                color: "#616161",
              }}
            >
              Start your search with our extensive construction equipment
              listings to find excavators, skid steer loaders, earthmoving
              machines, backhoes, pavers to compactors and work tools.
            </Typography>
          </Box>
          {!mobMatch && (
            <Box
              sx={{
                minWidth: "422px",
                height: "300px",
                borderRadius: "16px",
                backgroundColor: "#F5F5F5",
                display: "flex",
                justifyContent: "center",
                alignItems: "end",
                boxShadow:
                  "0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.2) ",
                marginBottom: "72px",
              }}
            >
              <img width="338px" height="264px" src={Search} alt="search" />
            </Box>
          )}
          {mobMatch && (
            <Box sx={{ marginY: "32px" }}>
              <img width="327px" height="237px" src={MobSearch} alt="search" />
            </Box>
          )}
        </Box>
        {/*  */}
        <Box
          sx={{
            display: "flex",
            columnGap: "56px",
            alignItems: "center",
            flexFlow: { xs: "column", sm: "row" },
            justifyContent: "space-between",
          }}
        >
          {!mobMatch && (
            <Box
              sx={{
                minWidth: "422px",
                height: "300px",
                borderRadius: "16px",
                backgroundColor: "#F5F5F5",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                boxShadow:
                  "0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.2) ",
                marginBottom: "72px",
              }}
            >
              <img width="342px" height="164px" src={Details} alt="details" />
            </Box>
          )}
          <Box sx={{ textAlign: { xs: "center", sm: "start" } }}>
            <Typography
              variant={mobMatch ? "subtitle1" : "h3"}
              sx={{
                fontSize: { xs: "16px", sm: "22px" },
                lineHeight: { xs: "24px", sm: "26px" },
                fontWeight: "600",
                color: "text.primary",
                marginBottom: "8px",
              }}
            >
              2. Learn details
            </Typography>
            <Typography
              variant={mobMatch ? "body2" : "body1"}
              sx={{
                fontSize: { xs: "14px", sm: "16px" },
                lineHeight: { xs: "20px", sm: "24px" },
                fontWeight: "400",
                color: "#616161",
              }}
            >
              Learn details about multiple machinery from our detail page or use
              our ‘Filter’ or ‘Compare listing’ feature to narrow down your
              search.
            </Typography>
          </Box>
          {mobMatch && (
            <Box sx={{ marginY: "32px" }}>
              <img width="327px" height="237px" src={MobDetails} alt="search" />
            </Box>
          )}
        </Box>
        {/*  */}
        <Box
          sx={{
            display: "flex",
            columnGap: "56px",
            alignItems: "center",
            flexFlow: { xs: "column", sm: "row" },
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ textAlign: { xs: "center", sm: "start" } }}>
            <Typography
              variant={mobMatch ? "subtitle1" : "h3"}
              sx={{
                fontSize: { xs: "16px", sm: "22px" },
                lineHeight: { xs: "24px", sm: "26px" },
                fontWeight: "600",
                color: "text.primary",
                marginBottom: "8px",
              }}
            >
              3. Contact seller
            </Typography>
            <Typography
              variant={mobMatch ? "body2" : "body1"}
              sx={{
                fontSize: { xs: "14px", sm: "16px" },
                lineHeight: { xs: "20px", sm: "24px" },
                fontWeight: "400",
                color: "#616161",
              }}
            >
              Once you've found what you're looking for Contact seller in few
              clicks to buy the machinery.
            </Typography>
          </Box>
          {!mobMatch && (
            <Box
              sx={{
                minWidth: "422px",
                height: "300px",
                borderRadius: "16px",
                backgroundColor: "#F5F5F5",
                display: "flex",
                justifyContent: "center",
                alignItems: "start",
                boxShadow:
                  "0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.2) ",
                marginBottom: "72px",
              }}
            >
              <img width="338px" height="264px" src={Contact} alt="contact" />
            </Box>
          )}
          {mobMatch && (
            <Box sx={{ marginY: "32px" }}>
              <img width="327px" height="237px" src={MobContact} alt="search" />
            </Box>
          )}
        </Box>
      </Container>
    </Box>
  );
}

export default Working;
